import { useFeatureFlags } from "../../../context/flags";

/**
 * Page tabs and their commands go through `artis.v1.pages`.
 * Off, the legacy page hooks and the in-memory PRA tab stay as they are.
 * The pages channel needs the Artis SDK, so `artis-api` has to be on as well.
 */
export const useArtisPagesEnabled = (): boolean => {
  const [artisPages, artisApi] = useFeatureFlags("artis-pages", "artis-api");
  return Boolean(artisPages && artisApi);
};
